import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, withRouter, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isAuthenticated } from '../../util/jwt';
import { showNotification } from '../../notifications/actions';

const mapDisptachToProps = dispatch => ({
  showLoggedOut: () => dispatch(
    showNotification('Login Expired', 'please log in again', 'error', 10))
});

class ProtectedRoute extends Component {
  render () {
    const props = { ...this.props };
    if (!isAuthenticated()) {
      this.props.showLoggedOut();
      props.render = props => (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location }
          }}
        />
      );
    }
    return <Route { ...props } />;
  }
}

ProtectedRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  render: PropTypes.func,
  showLoggedOut: PropTypes.func.isRequired
};

export default withRouter(connect(null, mapDisptachToProps)(ProtectedRoute));
